import { Component, Show, createMemo, createEffect, onCleanup } from "solid-js";
import { Motion, Presence } from "solid-motionone";
import { useItemOrderContext } from "~/utils/contexts";
import { InfoBox } from "~/components/utility";
import fractionString from "~/utils/fraction";

export const RailLengthWarning: Component<{ max?: number; min?: number }> = (
  props,
) => {
  const { orderData, setOrderData } = useItemOrderContext();

  let max = props.max || 116;
  let min = props.min || 4;

  // * Very convoluted memos that check whether the join is too big/small.
  // * Stack logic & typescript safety make this very unreadable, need to
  // * refactor. External function that does the math, returns the final
  // * inside/outside dimenions that can be checked against min/max here.
  const tooBig = createMemo(() => {
    // ? make sure w/h/moulding width exist
    if (!orderData.selected?.railLength || !orderData.width) return false;

    if (orderData.selected.sizing === "I") {
      if (
        // Inside sizing, non-stack:
        orderData.selected?.railLength + orderData.width * 2 >
        max
      ) {
        return true;
      }
    } else {
      if (orderData.selected.railLength > max) {
        return true;
      }
    }
    return false;
  });
  const tooSmall = createMemo(() => {
    // ? make sure w/h/moulding width exist
    if (!(orderData.selected?.railLength && orderData?.width)) return false;

    if (orderData.selected.sizing === "O") {
      if (
        // Outide sizing, non-stack:
        orderData.selected.railLength - orderData.width * 2 <
        min
      ) {
        return true;
      }
    } /* Inside Sizing */ else {
      // Inside sizing, non-stack/stack (stack irrelevant for inside sizing)
      if (orderData.selected.railLength < min) {
        return true;
      }
    }
    return false;
  });

  createEffect(() => {
    if (tooBig() || tooSmall()) {
      setOrderData("selected", "validDimensions", false);
    } else {
      setOrderData("selected", "validDimensions", true);
    }
    onCleanup(() => {
      setOrderData("selected", "validDimensions", true);
    });
  });

  return (
    <>
      <Presence exitBeforeEnter>
        <Show when={tooSmall()}>
          <Motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{
              opacity: 0,
              y: 20,
              transition: { duration: 0.4 },
            }}
            transition={{ duration: 0.4, easing: "ease-in-out" }}
          >
            <InfoBox type="warning">
              Please ensure a minimum length of of{" "}
              <span class="fraction">{fractionString(min)}</span>
            </InfoBox>
          </Motion.div>
        </Show>
      </Presence>
      <Presence exitBeforeEnter>
        <Show when={tooBig()}>
          <Motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{
              opacity: 0,
              y: 20,
              transition: { duration: 0.4 },
            }}
            transition={{ duration: 0.4, easing: "ease-in-out" }}
          >
            <InfoBox type="warning">
              <p>
                Please ensure a maximum length of{" "}
                <span class="fraction">{fractionString(max)}</span>
              </p>
            </InfoBox>
          </Motion.div>
        </Show>
      </Presence>
    </>
  );
};
